// extracted by mini-css-extract-plugin
module.exports = {"template":"medical-prescriptopn-dialog-email_template__NUnyr"};